import { mainnet, sepolia, optimism, holesky } from 'wagmi/chains';
import { Chain } from 'viem';
import localConfig from 'mode-shared/configs/config';

export const mode = {
  id: 34443,
  name: 'Mode',
  nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
  rpcUrls: {
    default: {
      http: ['https://mainnet.mode.network'],
    },
    public: {
      http: ['https://mainnet.mode.network'],
    },
  },
  blockExplorers: {
    default: {
      name: 'Blockscout',
      url: 'https://explorer.mode.network',
    },
  },
  contracts: {},
  testnet: false,
} as const satisfies Chain;

export const mainnetUpdated = {
  ...mainnet,
  rpcUrls: {
    default: {
      http: [localConfig.l1Rpc],
    },
    public: {
      http: [localConfig.l1Rpc],
    },
  },
} as const satisfies Chain;

export const optimismUpdated = {
  ...optimism,
  rpcUrls: {
    default: {
      http: ['https://mainnet.optimism.io'],
    },
    public: {
      http: ['https://mainnet.optimism.io'],
    },
  },
} as const satisfies Chain;

export const modeTestnet = {
  id: 919,
  name: 'Mode-sepolia',
  nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
  rpcUrls: {
    default: {
      http: ['https://sepolia.mode.network'],
    },
    public: {
      http: ['https://sepolia.mode.network'],
    },
  },
  blockExplorers: {
    default: {
      name: 'Blockscout',
      url: 'https://sepolia.explorer.mode.network',
    },
  },
  contracts: {},
  testnet: true,
} as const satisfies Chain;

export const sepoliaUpdated = {
  ...sepolia,
  rpcUrls: {
    default: {
      http: [localConfig.l1Rpc],
    },
    public: {
      http: [localConfig.l1Rpc],
    },
  },
} as const satisfies Chain;

export const holeskyUpdated = {
  ...holesky,
  rpcUrls: {
    default: {
      http: ['https://rpc.holesky.ethpandaops.io'],
    },
    public: {
      http: ['https://ethereum-holesky.publicnode.com'],
    },
  },
} as const satisfies Chain;
